import CryptoJS from 'crypto-js';

const CRYPTO_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY || "";

// Encrypt helper
function encrypt(text) {
  return CryptoJS.AES.encrypt(text, CRYPTO_KEY).toString();
}

// Decrypt helper
function decrypt(cipherText) {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, CRYPTO_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return null;
  }
}

export { encrypt, decrypt };